import React, {useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import generateHex from './HexFileGenerator'
import RangeSlider from "react-bootstrap-range-slider";


export default function SettingsGenerator() {


    const [settings, setSettings] = useState({
        fwVersion: "FW>=201",       // not a setting itself
        measType: "schedule",
        measTimes: [],
        measInterval: 0,
        temp_threshold: 80,
        accDetectType: "side",
        acc_sensitivity: "5",
        acc_movement: "2",
        tx_radio: "lora",
        otaa: "otaa",
        lora_region: "EU868",
        loraConfirmedMsgTimeThreshold: 0,
        gatewayIP: "40.119.156.2",
        NBIOT_operator: "23102",
        nbiot_apn: "0",
        ntpServer: "216.239.35.4",
        minRxWindowEu: 10,
        minRxWindowUs: 17,
        timeZoneOffset: 0,
        logEnable: 0,
        gateway_port: 4004,
        primaryDns: "8.8.8.8",
        secondaryDns: "8.8.4.4",
        uplinkUrl: "uplink.sensoneo.com",
    })

    const [showErrorAlert, setShowErrorAlert] = useState(false)

    const handleClickMeasTimes = (e) => {
        if (settings.measTimes.includes(e.target.value)) {
            // remove
            setSettings({...settings, measTimes: settings.measTimes.filter(item => item !== e.target.value)})
        } else {
            // add to list
            setSettings({...settings, measTimes: [...settings.measTimes, e.target.value]})
        }
    }

    const handleLoraRegionChange = (e) => {
        setSettings({
            ...settings,
            lora_region: e.target.value,
            //set default values to dependent settings
            lora_subband: "2",
            minRxWindowEu: 10,
            minRxWindowUs: 17
        })
    }


    function generateHexClicked() {
        console.log(settings)

        // validate meas times
        if ((settings.measType === "schedule") && (settings.measTimes.length === 0)) {
            setShowErrorAlert(true)
            return
        }
        let hex_string = generateHex(settings);
        const element = document.createElement("a");
        const file = new Blob([hex_string], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "hexFile.hex";
        document.body.appendChild(element);
        element.click();
    }

    const handleFile = e => {
        const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0], "UTF-8");
        fileReader.onload = file => {
            // console.log("file.target.result", file.target.result);
            let read_json = file.target.result;
            setSettings(JSON.parse(read_json))
        };
    }

    return (
        <div className="container-fluid ml-5">

            <Modal show={showErrorAlert} onHide={() => setShowErrorAlert(false)}>
                <Modal.Header closeButton>
                    <Modal.Title style={{color: "red"}}>Errors in form!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <p>There must be selected at least 1 hour in <b>Measurement times</b></p>
                </Modal.Body>
            </Modal>

            <div className="row pt-3 pb-2">

                <div className="col-8 p-2">
                    <h4 className="pb-2">1. Import settings from JSON file</h4>
                    <input className="p-3" type="file" accept=".json, .txt" onChange={handleFile}
                           style={{width: "100%"}}/>
                </div>
            </div>

            <hr style={{height: "5px", color: "green"}}/>

            <h4>2. or fill it manually</h4>

            <div className="row pt-3 pb-2">
                <h5>FW Version</h5>
                <div className='col-8 p-2'>
                    <select className="form-select"
                            value={settings.fwVersion}
                            onChange={event => {
                                setSettings({...settings, fwVersion: event.target.value})
                    }}>
                        <option value="FW>=201">FW&gt;=201</option>
                        <option value="FW<201">FW&lt;201</option>
                    </select>
                </div>
            </div>


            <div className="row pt-3 pb-2">
                <div className="col-lg-3 col-md-5">
                    <h5>Measurement type</h5>
                    <select className="form-select"
                            value={settings.measType}
                            onChange={event => {
                                setSettings({...settings, measType: event.target.value})
                            }}>
                        <option value="off">Off</option>
                        <option value="schedule">Schedule</option>
                        <option value="interval">Interval</option>
                    </select>
                </div>

                <div className="col-lg-4 offset-lg-1 col-md-6 offset-md-1 mt-4 mt-md-0">
                    {settings.measType === "schedule" ?
                        <div>
                            <h5>Measurement times</h5>
                            <p>minimum 1 selected</p>
                            <div role="group" onClick={handleClickMeasTimes}>
                                <div className="row">
                                    {["01", "02", "03", "04", "05", "06"].map(item => (
                                        <button type="button" key={item} className="btn col-2"
                                                style={{backgroundColor: settings.measTimes.includes(item) ? "#40B14B" : "#868e96"}}
                                                value={item}>{item}</button>
                                    ))
                                    }
                                </div>
                                <div className="row">
                                    {["07", "08", "09", "10", "11", "12"].map(item => (
                                        <button type="button" key={item} className="btn col-2"
                                                style={{backgroundColor: settings.measTimes.includes(item) ? "#40B14B" : "#868e96"}}
                                                value={item}>{item}</button>
                                    ))
                                    }
                                </div>
                                <div className="row">
                                    {["13", "14", "15", "16", "17", "18"].map(item => (
                                        <button type="button" key={item} className="btn col-2"
                                                style={{backgroundColor: settings.measTimes.includes(item) ? "#40B14B" : "#868e96"}}
                                                value={item}>{item}</button>
                                    ))
                                    }
                                </div>
                                <div className="row">
                                    {["19", "20", "21", "22", "23", "24"].map(item => (
                                        <button type="button" key={item} className="btn col-2"
                                                style={{backgroundColor: settings.measTimes.includes(item) ? "#40B14B" : "#868e96"}}
                                                value={item}>{item}</button>
                                    ))
                                    }
                                </div>
                            </div>
                            <div className="row pt-2">
                                <button type="button"
                                        className="btn btn-light col-5"
                                        onClick={event => {
                                            setSettings({
                                                ...settings, measTimes: ["01", "02", "03", "04", "05", "06", "07",
                                                    "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"]
                                            })
                                        }
                                        }>Select all
                                </button>
                                <button type="button"
                                        className="btn btn-light col-5 offset-2"
                                        onClick={e => {
                                            setSettings({...settings, measTimes: []})
                                        }}>Deselect all
                                </button>
                            </div>
                        </div>
                        :
                        null}
                    {settings.measType === "interval" ?
                        <div>
                            <h5>Measurement interval</h5>
                            <div className="row">
                                <div className="col-6">
                                    <input type="number" className="form-control"
                                           value={settings.measInterval}
                                           min={0}
                                           max={86400}
                                           onChange={e => {
                                              setSettings({...settings, measInterval: e.target.value})
                                               }
                                           }/>
                                    <small className="form-text" style={{color: "grey"}}>Range 0 - 86400</small>
                                </div>
                                <div className="col-6">
                                    <p>seconds</p>
                                </div>
                            </div>


                        </div>
                        :
                        null}
                </div>


            </div>
            <hr/>
            <div className="row pb-2 pt-2">
                <div className="col-12">
                    <h5>Fire alarm temperature threshold</h5>
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <RangeSlider
                                value={settings.temp_threshold}
                                min={0}
                                max={100}
                                onChange={e => {
                                    setSettings({...settings, temp_threshold: e.target.value})
                                }}
                                variant='success'
                            />
                        </div>
                        <p className="col-sm-2 col-md-4">{settings.temp_threshold} °C</p>
                    </div>

                </div>

            </div>

            <hr/>
            <div className="row pb-2 pt-2">
                <div className="col-12 col-md-3">
                    <h5>Collection type</h5>
                    <select className="form-select"
                            value={settings.accDetectType}
                            onChange={event => {
                                setSettings({...settings, accDetectType: event.target.value})
                            }}>
                        <option value="none">None collection</option>
                        <option value="side">Side collection</option>
                        <option value="vertical">Vertical collection</option>
                    </select>
                </div>
                <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                    <h5>Acc sensitivity</h5>
                    <select className="form-select"
                            value={settings.acc_sensitivity}
                            onChange={event => {
                                setSettings({...settings, acc_sensitivity: event.target.value})
                            }}>
                        <option value="1">1 (high)</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5 (normal)</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9 (low)</option>
                    </select>
                </div>
                <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                    <h5>Bin movement duration</h5>
                    <select className="form-select"
                            value={settings.acc_movement}
                            onChange={event => {
                                setSettings({...settings, acc_movement: event.target.value})
                            }}>
                        <option value="1">1 (slow)</option>
                        <option value="2">2 (normal)</option>
                        <option value="3">3 (fast)</option>

                    </select>
                </div>
            </div>
            <hr/>
            <div className="row pb-2 pt-2">
                <div className="col-12 col-md-3">
                    <h5>Network</h5>
                    <select className="form-select"
                            value={settings.tx_radio}
                            onChange={event => {
                                setSettings({...settings, tx_radio: event.target.value})
                            }}>
                        <option value="none">None</option>
                        <option value="lora">Lora</option>
                        <option value="sigfox">Sigfox</option>
                        <option value="nbiot">NBIoT</option>
                    </select>
                </div>
            </div>
            <hr/>
            <div className="row pb-2 pt-2">
                <div className="row">
                    <h5>LoRaWAN</h5>
                </div>
                <div className="row pt-3">
                    <div className="col-12 mt-2 col-md-3 mt-md-0">
                        <h6>Join procedure type</h6>
                        <select className="form-select"
                                value={settings.otaa}
                                onChange={event => {
                                    setSettings({...settings, otaa: event.target.value})
                                }}>
                            <option value="otaa">OTAA</option>
                            <option value="abp">ABP</option>
                        </select>
                    </div>
                    <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                        <h6>LoRaWan region</h6>
                        <select className="form-select"
                                value={settings.lora_region}
                                onChange={handleLoraRegionChange}>
                            <option value="AS923">AS923</option>
                            <option value="AU915">AU915</option>
                            <option value="EU868">EU868</option>
                            <option value="IN868">IN868</option>
                            <option value="US915">US915</option>
                            <option value="IL915">IL915</option>
                        </select>
                    </div>
                    <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                        <h6>LoRaWan subband</h6>
                        {["US915", "AU915", "AS923"].includes(settings.lora_region) ?
                            <select className="form-select"
                                    value={settings.lora_subband}
                                    onChange={event => {
                                        setSettings({...settings, lora_subband: event.target.value})
                                    }}>
                                {settings.lora_region === "US915" | settings.lora_region === "AU915" ?
                                    <option value="0">0</option> : null}
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                {settings.lora_region === "US915" | settings.lora_region === "AU915" ?
                                    <option value="5">5</option> : null}
                                {settings.lora_region === "US915" | settings.lora_region === "AU915" ?
                                    <option value="6">6</option> : null}
                                {settings.lora_region === "US915" | settings.lora_region === "AU915" ?
                                    <option value="7">7</option> : null}
                                {settings.lora_region === "US915" | settings.lora_region === "AU915" ?
                                    <option value="8">8</option> : null}
                            </select> :
                            <p>Unused for this region</p>}

                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-12 mt-2 col-md-3 mt-md-0">
                        <h6>Confirmed message interval (sec)</h6>
                        <input type="number" className="form-control"
                               value={settings.loraConfirmedMsgTimeThreshold}
                               min={0}
                               max={3600}
                               onChange={e => {
                                   setSettings({...settings, loraConfirmedMsgTimeThreshold: e.target.value})
                               }}
                        />
                        <small>Range 0 - 3600</small>
                    </div>
                    {settings.lora_region === "EU868" ?
                        <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                            <h6>EU868 RxWindow duration</h6>
                            <input type="number" className="form-control"
                                   value={settings.minRxWindowEu}
                                   onChange={e => {
                                     setSettings({...settings, minRxWindowEu: e.target.value})
                                   }}
                                   min={6}
                                   max={25}
                            />
                            <small className="form-text" style={{color: "red"}}>Only for experts!</small>
                        </div>
                        :
                        <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                            <h6 style={{color: "grey"}}>EU868 RxWindow duration</h6>
                            <input type="number" className="form-control"
                                   disabled
                                   value={""}
                            />
                            <small className="form-text" style={{color: "grey"}}>Not used in this region</small>
                        </div>
                    }
                    {settings.lora_region === "US915" ?
                        <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                            <h6>US915 RxWindow duration</h6>
                            <input type="number" className="form-control"
                                   value={settings.minRxWindowUs}
                                   onChange={e => {
                                     setSettings({...settings, minRxWindowUs: e.target.value})
                                   }}
                                   min={6}
                                   max={25}
                            />
                            <small className="form-text" style={{color: "red"}}>Only for experts!</small>
                        </div>
                        :
                        <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                            <h6 style={{color: "grey"}}>US915 RxWindow duration</h6>
                            <input type="number" className="form-control"
                                   disabled
                                   value={""}
                            />
                            <small className="form-text" style={{color: "grey"}}>Not used in this region</small>
                        </div>
                    }

                </div>
            </div>
            <hr/>
            <div className="row pb-2 pt-2">
                <div className="row">
                    <h5>NBIoT</h5>
                </div>
                <div className="row pt-3">
                    <div className="col-12 mt-2 col-md-3 mt-md-0">
                        <h6>PLMN</h6>
                        <input type="text" className="form-control"
                               value={settings.NBIOT_operator}
                               onChange={e => {
                                   setSettings({...settings, NBIOT_operator: e.target.value})
                               }}/>
                    </div>
                    <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                        <h6>APN</h6>
                        <input type="text" className="form-control"
                               value={settings.nbiot_apn}
                               onChange={e => {
                                   setSettings({...settings, nbiot_apn: e.target.value})
                               }}/>
                    </div>
                    <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                        <h6>NTP server IP</h6>
                        <input type="text" className="form-control"
                               value={settings.ntpServer}
                               onChange={e => {
                                   setSettings({...settings, ntpServer: e.target.value})
                               }}/>
                    </div>

                </div>
                <div className="row pt-3">
                    <div className="col-12
                    mt-2 col-md-3 mt-md-0">
                        <h6>IP of uplink server</h6>
                        <input type="text" className="form-control"
                               value={settings.gatewayIP}
                               onChange={e => {
                                  setSettings({...settings, gatewayIP: e.target.value})
                               }}/>
                    </div>
                    <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                        <h6>Uplink server UDP port</h6>
                        <input type="number" className="form-control"
                               value={settings.gateway_port}
                               onChange={e => {
                                   setSettings({...settings, gateway_port: e.target.value})
                               }}/>
                    </div>
                </div>
            </div>

            <hr/>
            <div className="row pb-2 pt-2">
                <div className="col-12 mt-2 col-md-3 mt-md-0">
                    <h5>Timezone offset</h5>
                    <input type="number" className="form-control"
                           value={settings.timeZoneOffset}
                           min={-24}
                           max={24}
                           onChange={e => {
                              setSettings({...settings, timeZoneOffset: e.target.value})
                           }}
                    />
                </div>
                <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                    <h5>Log enable</h5>
                    <select className="form-select"
                            value={settings.logEnable}
                            onChange={e => {
                                setSettings({...settings, logEnable: e.target.value})
                            }}>
                        <option value={0}>False</option>
                        <option value={4}>True</option>

                    </select>
                </div>
            </div>


            {settings.fwVersion === "FW>=201" && (
                <>
                 <hr/>
                 <div className="row pb-2 pt-2">
                    <span className="pb-2">Additional settings for FW{'>'}=201</span>
                     <div className="col-12 mt-2 col-md-3 mt-md-0">
                         <h5>Primary DNS</h5>
                         <input type="text" className="form-control"
                               value={settings.primaryDns}
                               onChange={e => {
                                   setSettings({...settings, primaryDns: e.target.value})
                               }}/>
                     </div>
                     <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                         <h5>Secondary DNS</h5>
                         <input type="text" className="form-control"
                               value={settings.secondaryDns}
                               onChange={e => {
                                   setSettings({...settings, secondaryDns: e.target.value})
                               }}/>
                     </div>

                     <div className="col-12 mt-2 col-md-3 offset-md-1 mt-md-0">
                         <h5>Uplink URL</h5>
                         <input type="text" className="form-control"
                               value={settings.uplinkUrl}
                               onChange={e => {
                                   setSettings({...settings, uplinkUrl: e.target.value})
                               }}/>
                     </div>
                 </div>
                 </>
            )}



            <div className="row pb-4 pt-4">
                <Button className="col-12 col-md-4 offset-md-1 p-3"
                        style={{backgroundColor: "green", borderColor: "green"}}
                        onClick={generateHexClicked}>Generate hex file</Button>
                <a
                    className="col-12 col-md-4 offset-md-2 mt-4 mt-md-0"
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(
                        JSON.stringify(settings, null, '\t')
                    )}`}
                    download="settings.json"
                >
                    <Button
                        className="p-3"
                        style={{width: "100%", color: "green", backgroundColor: "white", borderColor: "green",}}
                    >Export settings to JSON
                    </Button>
                </a>

            </div>


        </div>
    )
}